import createAxios from './http'

import getSign from '@/core'
import { getPhone ,getSecret, getKey } from '@/common/js/cache'
import encryptPhone from '@/core/phone'

const request = createAxios()

/**
* 拦截请求
*
*/
request.interceptors.request.use(
  config => {
    const accessSecret = getSecret()
    const accessKey = getKey()

    const timestamp = (new Date()).valueOf()
    const phone = getPhone()
    config.params = config.params || {}
    const params = config.params

    const signParams = {
      ...params,
      timestamp,
      accessKey,
      phone
    }

    const sign = getSign(signParams, accessSecret)
    config.params.timestamp = timestamp
    config.params.accessKey = accessKey
    config.params.sign = sign
    config.params.phone = phone
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 获取医生可预约时间列表
 * phone
    doctorId
    timestamp
    accessKey
sign
 */
export function getScheduleByDocId (params) {
  return request({
    url: '/doctor/getScheduleByDocId.htm',
    method: 'post',
    params
  })
}
/**
 * 预约医生时间（创建预约单）
phone
doctorId
scheduleId
key
timestamp
accessKey
sign
*/
export function addOrder (params) {
  // params.key = getKey()
  return request({
    url: '/order/addOrder.htm',
    method: 'post',
    params
  })
}

/**
 *获取与本人关系
phone
timestamp
accessKey
sign
*/
export function getRelationForSelf (params) {
  return request({
    url: '/patient/getRelationForSelf.htm',
    method: 'post',
    params
  })
}

/**
 * 获取视频目的
phone
timestamp
accessKey
sign
 * /patient/getPurpose.htm
*/
export function getPurpose (params) {
  return request({
    url: '/patient/getPurpose.htm',
    method: 'post',
    params
  })
}

/**
 * 填写病历
phone
orderId
realname
gender
birthday
relation
purpose
address
imgs
content
relationPhone
timestamp
accessKey
sign
 * /patient/addPatient.htm
*/
export function addPatient (params) {
  if (params.relationPhone.length > 0) {
    params.relationPhone = encryptPhone(params.relationPhone)
  }
  return request({
    url: '/patient/addPatient.htm',
    method: 'post',
    params
  })
}

/*
*预约单信息
接口说明：
3.接口地址 /order/getOrderInfo.htm
phone
orderId
timestamp
accessKey
sign
*/
export function getOrderInfo (params) {
  return request({
    url: '/order/getOrderInfo.htm',
    method: 'post',
    params
  })
}

/*
*预约单支付
接口说明：
3.接口地址 /order/payOrder.htm
phone
orderId
timestamp
accessKey
sign
*/
export function payOrder (params) {
  return request({
    url: '/order/payOrder.htm',
    method: 'post',
    params
  })
}


export function getOrderByPhone (params) {
  return request({
    url: '/order/getOrderByPhone.htm',
    method: 'post',
    params
  })
}

export function getOrderHistory (params) {
  return request({
    url: '/historyOrder/getOrder.htm',
    method: 'post',
    params
  })
}

export function activateProxyCard (params) {
  const {pwd} = params
  return request({
    url: '/proxyusercard/executeActivateProxyCard.htm',
    method: 'post',
    params:{
      cardPwd: encryptPhone(pwd)
    }
  })
}

export function getQinToken (params) {
  return request({
    url: '/qiniu/getQiniuToken.htm',
    method: 'post',
    params
  })
}


export function payRechargeOrder (params) {
  return request({
    url: '/order/payRechargeOrder.htm',
    method: 'post',
    params
  })
}


